import type { MicrosoftWindow } from "@components/cms/link/ModalLink";

const AGENT_AVAILABILITY_EVENT = "lcw:getAgentAvailability";

export const getIsChatAgentAvailable = (microsoftWindow: MicrosoftWindow): Promise<boolean> => {
    return new Promise((resolve, reject) => {
        const handleAvailability = (e: CustomEvent) => {
            const isAvailable = e?.detail?.isAgentAvailable || false;
            window.removeEventListener(
                AGENT_AVAILABILITY_EVENT,
                handleAvailability as EventListener
            );
            resolve(isAvailable);
        };

        window.addEventListener(AGENT_AVAILABILITY_EVENT, handleAvailability as EventListener);

        try {
            microsoftWindow.Microsoft.Omnichannel.LiveChatWidget.SDK.getAgentAvailability();
        } catch (error) {
            window.removeEventListener(
                AGENT_AVAILABILITY_EVENT,
                handleAvailability as EventListener
            );
            if (error instanceof Error) {
                reject(error);
            } else {
                reject(new Error(error ? String(error) : "Failed to get agent availability"));
            }
        }
    });
};
